/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailPasswordLoginInfo
 */
export interface EmailPasswordLoginInfo {
    /**
     * 
     * @type {string}
     * @memberof EmailPasswordLoginInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof EmailPasswordLoginInfo
     */
    password: string;
}

/**
 * Check if a given object implements the EmailPasswordLoginInfo interface.
 */
export function instanceOfEmailPasswordLoginInfo(value: object): value is EmailPasswordLoginInfo {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function EmailPasswordLoginInfoFromJSON(json: any): EmailPasswordLoginInfo {
    return EmailPasswordLoginInfoFromJSONTyped(json, false);
}

export function EmailPasswordLoginInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailPasswordLoginInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function EmailPasswordLoginInfoToJSON(json: any): EmailPasswordLoginInfo {
    return EmailPasswordLoginInfoToJSONTyped(json, false);
}

export function EmailPasswordLoginInfoToJSONTyped(value?: EmailPasswordLoginInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

